import create from "zustand";
import { persist } from "zustand/middleware";

const store = (set) => ({
  rightSideBarRecent: true,
  setRightSideBarRecent: (rightSideBarRecent) => set({ rightSideBarRecent }),
});

const configStore = create(persist(store));

export default configStore;
